import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function MotionEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = Array.from(document.querySelectorAll<HTMLElement>('main > section, main > header, main > footer'));

    sections.forEach((section) => {
      section.classList.add('motion-section');
      Array.from(section.querySelectorAll<HTMLElement>('article')).forEach((card, index) => {
        card.classList.add('motion-card');
        card.style.setProperty('--motion-index', String(index % 6));
      });
    });

    if (reduceMotion) {
      sections.forEach((section) => section.classList.add('motion-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('motion-visible');
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.1, rootMargin: '0px 0px -7% 0px' },
    );

    sections.forEach((section, index) => {
      if (index < 2) section.classList.add('motion-visible');
      else observer.observe(section);
    });

    return () => observer.disconnect();
  }, [location.pathname, location.search]);

  return null;
}
